import { internalErrorBusinessComp } from '../../../../../Components/InternalError/InternalError';
import {
  AssociationList,
  IAssociationListConfig,
} from './AssociationList/AssociationList';
import {
  IObjektVy,
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../Types/ObjektVy';
import { IClientBusinessModel } from '../../../../../Types/ClientModelTypes';
import { findCollectionStaticSafe } from '../../../../../Model/avenyStaticModelUtils';
import { selectedId } from '../../../../../Components/MasterDetail/MasterDetailUtils';

/** skapar en vy som visar en lista av associerade objekt */
export const associeradListVy = (
  associationName: string,
  /** kan innehålla customDefaultColumns */
  config?: IAssociationListConfig
): IObjektVy => ({
  type: 'ObjektVy',
  id: `${associationName}`,
  info: { komponentMedRubrik: config && config.noCaption },
  def: (businessModel: IClientBusinessModel): IObjektVyComp => {
    const assoc = businessModel.Associations[associationName];
    if (assoc) {
      const displaylabel = assoc.DisplayLabel;
      const assocBmod: IClientBusinessModel = findCollectionStaticSafe(
        assoc.AssociatedCollectionName,
        'felaktig association'
      );
      return {
        caption: displaylabel,
        comp: (props: IBusinessCollectionProps) => (
          <AssociationList
            collectionName={businessModel.CollectionName}
            associationName={associationName}
            ownId={selectedId(props.id)}
            associatedCollectionFieldName={assocBmod.CollectionName}
            config={config || {}}
            leftPadding
          />
        ),
      };
    }
    return {
      caption: `${associationName} - fel`,
      comp: internalErrorBusinessComp(
        'c6e7051d-7fb0-4559-8e20-607d279adefd',
        `${associationName} saknas`
      ),
    };
  },
});

export default associeradListVy;
